module.exports = __webpack_public_path__ + "static/img/drip-symbol-logo.f343a509.svg";